
const APP_ROUTES = {
    LOGIN: "/",
    ABOUT: "/about",
    QCDASH: "/QCDASH",
    DropDown: "/Dropdown",
    Users: "/Users",
    KYC_OVERRIDE: "/KycOverride",
    SAMPLE_FARMER: "/sample_farmer",
    Bulk_Update: "/Bulk_Update",
    Add_Location: "/add-location",
    FARMER_KYC_ENABLE: "/farmer-kyc-enable",
    GT_DASHBOARD: "/gt-dashboard",
    LONG_SURVEY_UPLOAD: "/long-survey-upload",
};

const API_CONSTANTS = {
    APPLICATION_CODE: 'GO',
    APP_CODE: 'IAMDASHBRD',
    APP_VERSION: 1
}

export { APP_ROUTES, API_CONSTANTS };
